import type {
  IStockCostAdjustmentModel,
  IStockCostAdjustmentStore,
} from '@monorepo/types/check/stockCostAdjustment/stockCostAdjustment.types';
import { getSevenDays } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IStockCostAdjustmentStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    date: getSevenDays(),
    sort_order: 'CREATED_DESC',
    order_state: '',
  },
  auditNo: '',
  cachePath: '/',
};

const StockCostAdjustmentModel: IStockCostAdjustmentModel = {
  namespace: 'stockCostAdjustmentStore',
  state: initState,
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    resetInit() {
      return { ...initState };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
  },
};

export { initState as initParams };

export default StockCostAdjustmentModel;
